import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GripVertical, ChevronUp, ChevronDown } from "lucide-react";
import { api } from "../../lib/api";
import CampaignsPanel from "./CampaignsPanel";

const eur = (v) => (v == null ? "—" : `€${Number(v).toLocaleString("it-IT", { maximumFractionDigits: 0 })}`);
const KEY = "athanor.clientOrder";
const loadOrder = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

// Un riquadro per cliente (account Meta seguito), trascinabile per scegliere l'ordine; con un solo account → pannello unico
export default function CampaignsByClient() {
  const [accounts, setAccounts] = useState(null);
  const [order, setOrder] = useState(loadOrder);
  const [drag, setDrag] = useState(null);
  useEffect(() => { api.get("/meta/clients").then(({ data }) => setAccounts(data.connected ? data.clients : [])).catch(() => setAccounts([])); }, []);
  if (!accounts || accounts.length <= 1) return <CampaignsPanel />;
  const sorted = [...accounts].sort((a, b) => {
    const ia = order.indexOf(a.ad_account_id), ib = order.indexOf(b.ad_account_id);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });
  const dropOn = (targetId) => {
    if (!drag || drag === targetId) return;
    const ids = sorted.map((c) => c.ad_account_id).filter((id) => id !== drag);
    ids.splice(ids.indexOf(targetId), 0, drag);
    setOrder(ids); localStorage.setItem(KEY, JSON.stringify(ids)); setDrag(null);
  };
  const move = (id, dir) => {
    const ids = sorted.map((c) => c.ad_account_id);
    const i = ids.indexOf(id), j = i + dir;
    if (j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    setOrder(ids); localStorage.setItem(KEY, JSON.stringify(ids));
  };
  return (
    <div className="space-y-4" data-testid="campaigns-by-client">
      <p className="text-xs text-slate-500">Trascina un riquadro (o usa le frecce) per cambiare l'ordine dei clienti · clicca il nome per aprire Meta Ads filtrato.</p>
      {sorted.map((c, idx) => (
        <div key={c.ad_account_id} draggable onDragStart={() => setDrag(c.ad_account_id)} onDragOver={(e) => e.preventDefault()} onDrop={() => dropOn(c.ad_account_id)}
          className={`relative rounded-xl transition-opacity ${drag === c.ad_account_id ? "opacity-50" : ""}`} data-testid={`client-block-${c.ad_account_id}`}>
          <div className="absolute left-1 top-4 flex flex-col items-center gap-0.5 text-slate-600">
            <button onClick={() => move(c.ad_account_id, -1)} disabled={idx === 0} className="disabled:opacity-20 hover:text-[#C5A059]" data-testid={`client-up-${c.ad_account_id}`} title="Sposta su"><ChevronUp className="h-3.5 w-3.5" /></button>
            <GripVertical className="h-4 w-4 cursor-grab" />
            <button onClick={() => move(c.ad_account_id, 1)} disabled={idx === sorted.length - 1} className="disabled:opacity-20 hover:text-[#C5A059]" data-testid={`client-down-${c.ad_account_id}`} title="Sposta giù"><ChevronDown className="h-3.5 w-3.5" /></button>
          </div>
          <CampaignsPanel client={c.ad_account_id}
            title={<Link to={`/meta-ads?client=${c.ad_account_id}`} className="hover:text-[#C5A059] hover:underline" data-testid={`client-title-${c.ad_account_id}`}>{c.client_name}</Link>}
            subtitle={`Spesa mese ${eur(c.spend_month)}${c.budget ? ` su ${eur(c.budget)} (${c.budget_pct}%)` : ""} · ${c.leads_30} lead negli ultimi 30 gg`} />
        </div>
      ))}
    </div>
  );
}
